import { atom } from 'recoil';

import { UserTheme } from '@gitbook/app-database';
import { localStorage } from '@gitbook/util-local-storage';

/**
 * The user's theme preference for the app.
 */
export const userThemeAtom = atom<UserTheme>({
    key: 'userThemeAtom',
    default: UserTheme.Default,
    effects: [localStorage.recoilEffect('@recoil/userThemeAtom', UserTheme.Default)],
});
